export default {
      id: "common__notice_disabled-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__notice_disabled",
      toString: function () {
        return this.url;
      }
    }